package com.evoapps.evoshift.auth

import com.evoapps.evoshift.domain.provider.AppleSignIn
import com.evoapps.evoshift.domain.provider.AppleSignInClient
import com.evoapps.evoshift.domain.usecase.auth.SignInMethodDisabledException
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.auth.externals.OAuthProvider
import dev.gitlive.firebase.auth.externals.signInWithPopup
import dev.gitlive.firebase.auth.js
import kotlinx.coroutines.await

/**
 * Firebase's own apple.com popup (SH-92), as for Google. It signs in by itself (Firebase checks
 * the nonce it generated), so the repository only completes the profile.
 */
class WebAppleSignInClient : AppleSignInClient {
    override val isAvailable: Boolean = true

    override suspend fun signIn(): AppleSignIn? {
        val provider = OAuthProvider(APPLE_PROVIDER_ID).apply {
            // Apple shares the name and the (possibly private-relay) e-mail only the first time.
            addScope("email")
            addScope("name")
        }
        val result = try {
            signInWithPopup(Firebase.auth.js, provider).await()
        } catch (e: Throwable) {
            // Closing the popup is not an error worth showing.
            val code = e.asDynamic().code as? String
            if (code in CANCELLED) return null
            if (code == "auth/operation-not-allowed") throw SignInMethodDisabledException()
            // A JS Error is not a Kotlin Exception: hand the callers one they catch.
            throw IllegalStateException("Apple sign-in failed: ${code ?: e.message}", e)
        }
        return AppleSignIn.SignedIn(fullName = result.user.displayName)
    }

    private companion object {
        const val APPLE_PROVIDER_ID = "apple.com"
        val CANCELLED = setOf("auth/popup-closed-by-user", "auth/cancelled-popup-request", "auth/user-cancelled")
    }
}
